export default function TermsPage() {
  return (
    <div data-testid="terms-page" className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-lg text-slate-600 mb-8">
              Last updated: December 2024
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-slate-600 mb-4">
                By accessing or using the Certisfy platform ("Service"), you agree to be bound by these 
                Terms of Service ("Terms"). If you do not agree to these Terms, you may not access or 
                use the Service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Description of Service</h2>
              <p className="text-slate-600 mb-4">
                Certisfy provides a cloud-based platform for phytosanitary certification and export 
                compliance management. The Service facilitates certificate applications, inspections, 
                approvals, and document generation for agricultural export compliance.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">3. User Responsibilities</h2>
              <p className="text-slate-600 mb-4">
                As a user of Certisfy, you agree to:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2">
                <li>Provide accurate and complete information in all applications</li>
                <li>Maintain the confidentiality of your account credentials</li>
                <li>Use the Service only for lawful purposes</li>
                <li>Not attempt to circumvent security measures</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Data Accuracy</h2>
              <p className="text-slate-600 mb-4">
                Users are responsible for the accuracy of all information submitted through the 
                Service. Submitting false or misleading information may result in certificate 
                rejection, account suspension, or legal action.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">5. Intellectual Property</h2>
              <p className="text-slate-600 mb-4">
                The Service and its original content, features, and functionality are owned by 
                Certisfy and are protected by international copyright, trademark, patent, trade 
                secret, and other intellectual property laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Limitation of Liability</h2>
              <p className="text-slate-600 mb-4">
                To the fullest extent permitted by law, Certisfy shall not be liable for any 
                indirect, incidental, special, consequential, or punitive damages resulting from 
                your use of or inability to use the Service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">7. Modifications</h2>
              <p className="text-slate-600 mb-4">
                We reserve the right to modify or replace these Terms at any time. We will provide 
                notice of any significant changes. Your continued use of the Service after such 
                modifications constitutes acceptance of the updated Terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">8. Governing Law</h2>
              <p className="text-slate-600 mb-4">
                These Terms shall be governed by and construed in accordance with the laws of 
                South Africa, without regard to its conflict of law provisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">9. Contact</h2>
              <p className="text-slate-600">
                If you have any questions about these Terms, please contact us at:<br />
                Email: legal@certisfy.com<br />
                Address: Pretoria, South Africa
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
